import { AntCollapse } from '@agro-club/agroclub-shared'
import { Bid, BidStatus } from 'modules/domain/bid/types'
import { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { WrapperCollapse } from 'views/components/Board/styled'
import { UserBidsObj } from '../../useUserBids'
import { BidsPanel } from './BidsPanel'

type Props = {
  setActiveBid: (arg: Bid) => void
  activeBid?: Bid
  bids: UserBidsObj
}

export const BidsColumn: FC<Props> = ({ setActiveBid, activeBid, bids }) => {
  const { t } = useTranslation()
  const { progress, publishedBids, potentialBids, archivedBids, refetch } = bids

  const [activePanel, setActivePanel] = useState<BidStatus>()
  const { bidId, statusBid } = useParams()

  const scrollToActiveCard = () => {
    const el = document.getElementById(`${bidId}`)
    el?.scrollIntoView({ block: 'center', inline: 'center' })
  }

  useEffect(() => {
    if (!statusBid || statusBid === BidStatus.published) {
      setActivePanel(BidStatus.published)
      return
    }

    if (statusBid === BidStatus.archived) {
      setActivePanel(BidStatus.archived)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!statusBid && publishedBids.length) {
      setActiveBid(publishedBids[0])
      return
    }

    let active: Bid | undefined = undefined

    if (publishedBids.length && statusBid === BidStatus.published) {
      active = publishedBids.find((bid) => bid.id == bidId)
    }

    if (archivedBids.length && statusBid === BidStatus.archived) {
      active = archivedBids.find((bid) => bid.id == bidId)
    }

    if (active) {
      setActiveBid(active)
      scrollToActiveCard()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [publishedBids, archivedBids])

  if (!activePanel) {
    return
  }

  return (
    <WrapperCollapse>
      <AntCollapse defaultActiveKey={activePanel} noMarginTop accordion>
        <BidsPanel
          refetch={refetch}
          setActiveBid={setActiveBid}
          namePanel={t('bid:bids')}
          key={BidStatus.published}
          colorCount={'orange'}
          activeBid={activeBid}
          bids={publishedBids}
          progress={progress}
        />
        <BidsPanel
          namePanel={t('bid:archived_bids')}
          setActiveBid={setActiveBid}
          key={BidStatus.archived}
          activeBid={activeBid}
          colorCount={'grey'}
          bids={archivedBids}
          progress={progress}
        />
        <BidsPanel
          namePanel={t('bid:potential_bids')}
          key={BidStatus.potential}
          activeBid={activeBid}
          bids={potentialBids}
          colorCount={'grey'}
          progress={progress}
        />
      </AntCollapse>
    </WrapperCollapse>
  )
}
